import { ProgressSpinner } from "primereact/progressspinner";
import React, { Fragment, useContext, useEffect, useState } from "react"
import RechercheContext from './RechercheContext';
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { enumContextFormationThumbnail } from "../../enums/enumContextFormationThumbnail";
import { NewFormationThumbnail } from "../../components/thumbnail/newFormationThumbnail";
import { enumTypeRechercheAffinee } from "../../enums/enumTypeRechercheAffinee";
import { EtudiantThumbnail } from "../../components/thumbnail/etudiantThumbnail";
import { ThumbnailPaginator } from "../../components/paginator/thumbnailPaginator";
import { CandidateThumbnail } from "../../components/thumbnail/candidateThumbnail";
import { Link } from "react-router-dom";
import { enumCreditableShareEntreprise } from "../../enums/enumCreditableShareEntreprise";

export const RechercheAffineeResultats = (props) => {

    const { t } = useTranslation()
    const history = useHistory();
    const contextRecherche = useContext(RechercheContext);
    const adminImpersonatingRecruteurId = history.location?.state?.adminImpersonatingRecruteurId;
    const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

    useEffect(() => {
        if (!props.loading) setHasLoadedOnce(true);
    }, [props.loading]);

    return (
        <div className={props.className}>
            {props.loading ? (
                <div className="p-col-12" style={{ textAlign: 'center' }}>
                    <ProgressSpinner />
                </div>
            ) : (
                ((props.formations?.length > 0 && contextRecherche.typeRecherche == enumTypeRechercheAffinee.FORMATION) ||
                    (props.candidats?.length > 0 && contextRecherche.typeRecherche == enumTypeRechercheAffinee.CANDIDAT)) ? (
                    <>
                        {contextRecherche.typeRecherche == enumTypeRechercheAffinee.FORMATION && (
                            <div className={"container-for-horizontal-display"}>
                                {props.formations?.map((formation, indexFormation) => (
                                    <Fragment key={`${formation.id}~${indexFormation}`}>
                                        <NewFormationThumbnail
                                            formation={formation}
                                            className={"column-search-item"}
                                            context={enumContextFormationThumbnail.RECHERCHE}
                                            adminImpersonatingRecruteurId={adminImpersonatingRecruteurId}
                                        />
                                    </Fragment>
                                ))}
                            </div>
                        )}

                        {contextRecherche.typeRecherche == enumTypeRechercheAffinee.CANDIDAT && (
                            <div className={"container-for-horizontal-display"}>
                                {props.candidats?.map((candidat, indexCandidat) => (
                                    <Fragment key={`${candidat.id}~${indexCandidat}`}>
                                        <CandidateThumbnail etudiant={candidat} showLogo={true} className={"ra-column-search-item-candidate"} toast={props.toast} displayFakeInformation={props.displayFakeInformation} entrepriseId={props.entrepriseId} creditActionEnumCV={enumCreditableShareEntreprise.CVPAGECANDIDAT} creditActionEnumPortfolio={enumCreditableShareEntreprise.PORTFOLIOPAGECANDIDAT} />
                                    </Fragment>
                                ))}
                            </div>
                        )}
                    </>
                ) : (
                    (hasLoadedOnce && props.totalFormationsRecords === 0) ? t('search.no_results_matching') : null
                )
            )}
    
            {(props.formations?.length > 0 || props.candidats?.length > 0) && !props.loading && (
                <div className="p-mt-4 dip-ta-center">
                    <ThumbnailPaginator
                        lazyParams={props.lazyParams}
                        setLazyParams={props.setLazyParams}
                        totalRecords={props.totalFormationsRecords}
                        backgroundColor={props.backgroundColor}
                        onClickChangePage={props.onClickChangePage}
                    />
                </div>
            )}
        </div>
    );    
}